import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { setDynamicRemarketing } from '../actions/dynamic-remarketing';

const mapStateToDataLayer = (state, pageType) => {
  const result = {
    pageType,
  };

  if (state.bag && state.bag.items) {
    result.bag = state.bag;
  }
  if (state.auth && state.auth.user) {
    const { id, email, dateWebRegistered, recency } = state.auth.user;
    result.user = { id, email, dateWebRegistered, recency };
  }
  if (state.product) {
    const styleColour = state.product.styleColour;
    if (
      state.product.selectedStyleColour &&
      Object.keys(styleColour.data).length
    ) {
      result.product = styleColour.data;
      if (styleColour.selectedSku) {
        result.selectedSku = styleColour.selectedSku;
      }
    }
  }
  if (
    state.productListing &&
    state.productListing.items &&
    state.productListing.items.length
  ) {
    result.productListing = state.productListing;
  }
  if (
    state.checkout &&
    state.checkout.confirmed &&
    state.checkout.confirmed.orderId
  ) {
    result.transaction = state.checkout.confirmed;
  }

  result.hotjarEnabled = state.app.config.hotjarEnabled;

  return result;
};

const DataLayer = ({ dataLayer, onSetDynamicRemarketing }) => {
  useEffect(() => {
    onSetDynamicRemarketing();
  }, []);

  return (
    <Helmet
      script={[
        {
          innerHTML: `setDataLayer && setDataLayer(${JSON.stringify(
            dataLayer
          )});`,
        },
      ]}
    />
  );
};

DataLayer.propTypes = {
  dataLayer: PropTypes.object.isRequired,
  dataLayerReducer: PropTypes.func.isRequired,
  onSetDynamicRemarketing: PropTypes.func,
};

DataLayer.defaultProps = {
  dataLayer: {},
  dataLayerReducer: mapStateToDataLayer,
};

const mapStateToProps = (state, ownProps) => ({
  dataLayer: {
    ...mapStateToDataLayer(state, ownProps.pageType),
    ...(ownProps.dataLayerReducer
      ? ownProps.dataLayerReducer(state, ownProps.pageType)
      : {}),
  },
  pathname: state.app.routing.pathname,
  ...ownProps,
});

const mapDispatchToProps = dispatch => ({ dispatch });

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onSetDynamicRemarketing: () => {
    // We set dynamic retargeting on the product page inside the setProduct action,
    // not on page load. This prevents it from being set twice.
    if (!stateProps.pathname.includes('products')) {
      dispatch(setDynamicRemarketing());
    }
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(DataLayer);

export const UnwrappedDataLayer = DataLayer;
